import * as React from 'react';

import { APP_DEGRADED_ATTRIBUTE } from '../../constants/hydration';

interface ISsrMarkupFallbackProps {
  /** innerHTML корневого элемента, снятый до hydrateRoot */
  html: string;
}

/**
 * Заглушка корневого error boundary: возвращает в DOM серверную разметку,
 * чтобы при ошибке после гидрации страница не превращалась в пустой <span>.
 * Интерактивность теряется, контент и ссылки остаются (важно для поисковых ботов).
 * display: contents, чтобы обёртка не ломала раскладку корневого элемента.
 */
export const SsrMarkupFallback: React.FC<ISsrMarkupFallbackProps> = ({ html }) => {
  React.useEffect(() => {
    document.documentElement.setAttribute(APP_DEGRADED_ATTRIBUTE, 'true');
  }, []);

  // oxlint-disable-next-line react/no-danger
  return <div style={{ display: 'contents' }} dangerouslySetInnerHTML={{ __html: html }} />;
};
